import * as React from 'react';
import PropTypes from "prop-types";
import FAddress from "../../app/widgets/FAddress";
import {MenuItem, TextField} from "@mui/material";

function AltLocation(props) {
    return props.locations == null ? (
        <FAddress
            label={props.label}
            value={props.value}
            onChange={point => props.onChange(point)}
            autoFocus={props.autoFocus}
            disabled={props.disabled}/>
    ) : (
        <TextField
            label={props.label}
            value={props.value.address}
            onChange={e => {
                let loc = props.locations.find(o => o.address == e.target.value);
                props.onChange({
                    lat    : loc.lat,
                    lng    : loc.lng,
                    address: loc.address,
                });
            }}
            disabled={props.disabled}
            autoFocus={props.autoFocus}
            select>

            {props.locations.map(o => (
                <MenuItem key={o.id} value={o.address}>{o.address}</MenuItem>
            ))}

        </TextField>
    );
}

AltLocation.propTypes = {
    label    : PropTypes.string,
    locations: PropTypes.array,
    value    : PropTypes.exact({
        address: PropTypes.string,
        lat    : PropTypes.any,
        lng    : PropTypes.any,
    }).isRequired,
    onChange : PropTypes.func.isRequired,
    disabled : PropTypes.bool,
    autoFocus: PropTypes.bool,
};

export default AltLocation;